if (!customElements.get("m-cart-addons")) {
  class MCartAddons extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        zipCode: '[name="address[zip]"]',
        province: '[name="address[province]"]',
        country: '[name="address[country]"]',
        addressForm: '[data-address="root"]',
        shippingMessage: ".m-cart-addon__shipping-rate",
        cartDiscountCode: '[name="discount"]',
        cartDiscountCodeNoti: "[data-discount-noti]",
        cartNote: '[name="note"]',
        saveAddonButton: ".m-cart-addon--save",
        closeAddonButton: ".m-cart-addon--close",
        calcShippingButton: ".m-cart-addon--calculate",
        triggerAddonButton: ".m-cart-addon--trigger-button",
        devliveryTime: '[name="attributes[Delivery time]"]',
      };
    }

    connectedCallback() {
      this.cartWrapper = document.querySelector(".m-cart-drawer");
      this.isCartPage = MinimogSettings.templateName === "cart";
      if (this.isCartPage) {
        this.cartWrapper = document.querySelector(".m-cart__footer--wrapper");
      }
      this.initAddress = false;
      this.cartOverlay = this.cartWrapper.querySelector(".m-cart__overlay");
      this.domNodes = queryDomNodes(this.selectors, this);
      this.rootUrl = window.Shopify.routes.root;
      this.discountCodeKey = "minimog-discount-code";
      this.deliveryCodeKey = "minimog-delivery-code";
      this.init();
    }

    disconnectedCallback() {
      if (this._removeCloseAddonButton) this._removeCloseAddonButton();
      if (this._removeCalcShippingButton) this._removeCalcShippingButton();
    }

    init() {
      const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;
      addEventDelegate({
        selector: this.selectors.triggerAddonButton,
        context: this,
        handler: (e, addonButton) => {
          e.preventDefault();
          if (this.isCartPage) {
            const addonCurrentActive = document.querySelector(".m-cart-addon__body.open");
            if (addonCurrentActive) addonCurrentActive.classList.remove("open");
          }
          const { open: addonTarget } = addonButton.dataset;
          const addonNode = this.cartWrapper.querySelector(`#m-addons-${addonTarget}`);
          this.removeActiveAllButton();
          addonButton.classList.add("active");
          addonNode && addonNode.classList.add("open");
          this.cartOverlay && this.cartOverlay.classList.add("open");
          this.openAddon = addonNode;

          if (addonTarget === "shipping") {
            fetchSection("country-options", { url: window.MinimogSettings.base_url })
              .then((html) => {
                const select = html.querySelector("#AddressCountry");
                const options = select && select.querySelectorAll("option");
                const defaultSelect = addonNode.querySelector("#MadrressCountry select");
                options &&
                  options.forEach((option) => {
                    defaultSelect && defaultSelect.appendChild(option);
                  });
                this.setupCountries();
                defaultSelect.value = defaultSelect && defaultSelect.dataset.default;
              })
              .catch(console.error);
          }
        },
      });
      this._removeCloseAddonButton = addEventDelegate({
        selector: this.selectors.closeAddonButton,
        context: this.cartWrapper,
        handler: this.close.bind(this),
      });

      this._removeCalcShippingButton = addEventDelegate({
        selector: this.selectors.calcShippingButton,
        context: this.cartWrapper,
        handler: this.calcShipping.bind(this),
      });
      if (cartDiscountCode) {
        const code = localStorage.getItem(this.discountCodeKey);
        if (code) {
          cartDiscountCode.value = code;
          if (cartDiscountCodeNoti) {
            cartDiscountCodeNoti.style.display = "inline";
          }
        }
      }
      if (devliveryTime) {
        const code = localStorage.getItem(this.deliveryCodeKey);
        if (code) devliveryTime.value = code;
      }
      this.saveAddonValue();
      this.setupDiscountRemoveButtons();
      const today = new Date().toISOString().slice(0, 16);
      const deliveryTimeElm = this.querySelector("#delivery-time");
      if (deliveryTimeElm) deliveryTimeElm.min = today;
    }

    removeActiveAllButton() {
      const triggerButtons = this.querySelectorAll(this.selectors.triggerAddonButton);
      triggerButtons && triggerButtons.forEach((button) => button.classList.remove("active"));
    }

    setupCountries() {
      if (this.initAddress) return;
      if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
          hideElement: "AddressProvinceContainer",
        });
        this.initAddress = true;
      }
    }

    close(event) {
      const isApplying = sessionStorage.getItem('_isApplyingDiscount') === 'true';

      // Don't close if we're currently applying a discount
      if (isApplying) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      this.openAddon.classList.remove("open");
      this.cartOverlay && this.cartOverlay.classList.remove("open");
      this.removeActiveAllButton();
      this.openAddon = null;
    }

    calcShipping(event) {
      event.preventDefault();
      const actionsWrapper = event.target.closest(".m-cart-addon__action");
      actionsWrapper.classList.add("m-spinner-loading");
      const zipCode = this.domNodes.zipCode && this.domNodes.zipCode.value && this.domNodes.zipCode.value.trim();
      const country = this.domNodes.country.value;
      const province = this.domNodes.province.value;
      this.domNodes.shippingMessage.classList.remove("error");
      this.domNodes.shippingMessage.innerHTML = "";
      const showDeliveryDays = actionsWrapper.dataset.showDeliveryDays === "true";
      fetch(
        `${this.rootUrl}cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`
      )
        .then((res) => res.json())
        .then((res) => {
          if (res && res.shipping_rates) {
            const { shipping_rates } = res;
            const { shippingRatesResult, noShippingRate } = MinimogStrings;
            if (shipping_rates.length > 0) {
              actionsWrapper.classList.remove("m-spinner-loading");
              const shippingLabel = document.createElement("P");
              shippingLabel.classList.add("m-cart-addon__shipping-rate--label");
              shippingLabel.innerHTML = `${shippingRatesResult.replace("{{count}}", shipping_rates.length)}:`;
              this.domNodes.shippingMessage.appendChild(shippingLabel);
              shipping_rates.map((rate) => {
                const { deliveryOne = "Day", deliveryOther = "Days" } = actionsWrapper.dataset;
                let deliveryDays = "";
                if (rate.delivery_days.length > 0 && showDeliveryDays) {
                  let textDay = deliveryOne;
                  const firstDeliveryDay = rate.delivery_days[0];
                  const lastDeliveryDay = rate.delivery_days.at(-1);
                  if (firstDeliveryDay > 1) textDay = deliveryOther;
                  if (firstDeliveryDay === lastDeliveryDay) {
                    deliveryDays = `(${firstDeliveryDay} ${textDay})`;
                  } else {
                    deliveryDays = `(${firstDeliveryDay} - ${lastDeliveryDay} ${textDay})`;
                  }
                }
                const shippingRateItem = document.createElement("P");
                shippingRateItem.classList.add("m-cart-addon__shipping-rate--item");
                shippingRateItem.innerHTML = `${rate.name}: <span>${rate.price} ${Shopify.currency.active}</span> ${deliveryDays}`;
                this.domNodes.shippingMessage.appendChild(shippingRateItem);
              });
            } else {
              actionsWrapper.classList.remove("m-spinner-loading");
              this.domNodes.shippingMessage.innerHTML = `<p>${noShippingRate}</p>`;
            }
          } else {
            actionsWrapper.classList.remove("m-spinner-loading");
            Object.entries(res).map((error) => {
              this.domNodes.shippingMessage.classList.add(error[0] && error[0].toLowerCase());
              const message = `${error[1][0]}`;
              const shippingRateError = document.createElement("P");
              shippingRateError.classList.add("m-cart-addon__shipping-rate--error");
              shippingRateError.innerHTML = `${message}<sup>*</sup>`;
              this.domNodes.shippingMessage.appendChild(shippingRateError);
            });
          }
        })
        .catch(console.error);
    }

    saveAddonValue() {
      // Store the cleanup function if this is the first setup
      if (!window._saveAddonValueCleanup) {
        window._saveAddonValueCleanup = addEventDelegate({
          event: "click",
          context: document.documentElement,
          selector: this.selectors.saveAddonButton,
          handler: (event, target) => {
            event.preventDefault();

            // Find the cart addon instance
            const cartAddon = target.closest('m-cart-addons');
            if (!cartAddon) return;

            const cartDiscountCode = cartAddon.querySelector('input[name="discount"]');
            const cartDiscountCodeNoti = cartAddon.querySelector('[data-cart-discount-code]');
            const devliveryTime = cartAddon.querySelector('input[name="delivery"]');
            if (target.dataset.action === "coupon" && cartDiscountCode) {
              const code = cartDiscountCode.value.trim();

              if (code !== "") {
                // Show loading state
                const originalText = target.textContent;
                target.disabled = true;
                // Use centralized translation if available
                const applyingText = (window.themeTranslations && window.themeTranslations.t)
                  ? window.themeTranslations.t('applying')
                  : 'Applying...';
                target.textContent = applyingText;

                // Set flag to prevent addon from closing during apply process
                // Use sessionStorage so it persists across component re-renders
                sessionStorage.setItem('_isApplyingDiscount', 'true');

                // First, always clear any existing discount to ensure clean state
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({ discount: '' })
                })
                  .then(() => {
                    // Wait a moment for Shopify to process the clear
                    return new Promise(resolve => setTimeout(resolve, 500));
                  })
                  .then(() => {
                    // Now apply the actual discount
                    return fetch('/cart/update.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                      },
                      body: JSON.stringify({
                        discount: code
                      })
                    });
                  })
                  .then(response => response.json())
                  .then(cart => {
                    return new Promise((resolve, reject) => {
                      let attempts = 0;
                      const maxAttempts = 5;
                      const checkInterval = 400;

                      const checkDiscount = () => {
                        attempts++;

                        fetch('/cart.js')
                          .then(response => response.json())
                          .then(updatedCart => {
                            // Check if discount was actually applied
                            const hasDiscount = (updatedCart.cart_level_discount_applications && updatedCart.cart_level_discount_applications.length > 0) ||
                              (updatedCart.total_price < updatedCart.original_total_price) ||
                              updatedCart.items.some(item => item.discounts && item.discounts.length > 0);

                            if (hasDiscount) {
                              resolve(updatedCart);
                            } else if (attempts < maxAttempts) {
                              setTimeout(checkDiscount, checkInterval);
                            } else {
                              reject(new Error(window.MinimogStrings.cartError));
                            }
                          })
                          .catch(reject);
                      };

                      setTimeout(checkDiscount, 300);
                    });
                  })
                  .then(cart => {
                    localStorage.setItem('minimog-cart-discount-code', code);
                    if (cartDiscountCodeNoti) {
                      cartDiscountCodeNoti.style.display = "inline";
                    }

                    // Refresh cart sections
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                      detail: { open: !document.location.pathname.includes('/cart') }
                    }));

                    // Wait for refresh then close
                    setTimeout(() => {
                      const closeButton = cartAddon.querySelector('.m-cart-addon__close');
                      if (closeButton) closeButton.click();
                    }, 800);
                  })
                  .catch((error) => {
                    // Show error notification using theme's notification system
                    const discountAddonBody = document.querySelector('#m-addons-coupon .m-cart-addon__content');
                    if (window.MinimogTheme && window.MinimogTheme.Notification && discountAddonBody) {
                      window.MinimogTheme.Notification.show({
                        target: discountAddonBody,
                        type: "error",
                        message: error.message || window.MinimogStrings.cartError,
                        last: 3000,
                      });
                    }
                  })
                  .finally(() => {
                    sessionStorage.removeItem('_isApplyingDiscount');
                    target.disabled = false;
                    target.textContent = originalText;
                  });
              } else {
                // Clear discount - call the static method
                MCartAddons.prototype.removeDiscountCode.call(cartAddon).then(() => {
                  const closeButton = cartAddon.querySelector('.m-cart-addon__close');
                  if (closeButton) closeButton.click();
                });
              }
            }
            if (target.dataset.action === "note") {
              MCartAddons.prototype.updateCartNote.call(cartAddon);
              const closeButton = cartAddon.querySelector('.m-cart-addon__close');
              if (closeButton) closeButton.click();
            }
            if (target.dataset.action === "delivery") {
              const code = devliveryTime.value;
              const isValidDate = Date.parse(code);
              if (isValidDate > Date.now()) {
                localStorage.setItem('minimog-cart-delivery-code', code);
                const closeButton = cartAddon.querySelector('.m-cart-addon__close');
                if (closeButton) closeButton.click();
              } else {
                localStorage.setItem('minimog-cart-delivery-code', "");
                devliveryTime.value = "";
                window.MinimogTheme.Notification.show({
                  target: cartAddon.querySelector(".m-cart-addon-message-error"),
                  method: "appendChild",
                  type: "error",
                  message: window.MinimogStrings.valideDateTimeDelivery,
                  last: 3000,
                  sticky: false,
                });
              }
            }
          },
        });
      }
    }

    removeDiscountCode() {
      return new Promise((resolve, reject) => {
        const { cartDiscountCodeNoti } = this.domNodes;

        // Clear from localStorage
        localStorage.removeItem(this.discountCodeKey);
        if (cartDiscountCodeNoti) {
          cartDiscountCodeNoti.style.display = "none";
        }

        // Clear discount input field
        const discountInput = document.querySelector('input[name="discount"]');
        if (discountInput) {
          discountInput.value = '';
        }

        // Use Shopify's official Cart AJAX API to remove discount
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            discount: ''
          })
        })
          .then(response => response.json())
          .then(cart => {
            // Wait for Shopify's backend to fully process the removal
            return new Promise(waitResolve => {
              setTimeout(() => {
                this.refreshCartSections().then(waitResolve);
              }, 800);
            });
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    }

    refreshCartSections() {
      return new Promise((resolve, reject) => {
        // Prevent multiple simultaneous refreshes using sessionStorage
        const isRefreshing = sessionStorage.getItem('_isRefreshing');
        if (isRefreshing === 'true') {
          return resolve();
        }

        sessionStorage.setItem('_isRefreshing', 'true');

        // Use cart:refresh event which forces a full HTML refresh from server
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { open: !this.isCartPage }
        }));

        // Wait for the refresh to complete
        setTimeout(() => {
          sessionStorage.removeItem('_isRefreshing');
          resolve();
        }, 1000);
      });
    }

    setupDiscountRemoveButtons() {
      // Prevent multiple setups using a global flag
      if (window._discountRemoveButtonsSetup) {
        return;
      }
      window._discountRemoveButtonsSetup = true;

      // Add click handlers for discount removal
      addEventDelegate({
        event: "click",
        context: document.body,
        selector: ".m-cart__discount-remove",
        handler: (event, target) => {
          event.preventDefault();

          // Prevent multiple clicks
          if (target.disabled) {
            return;
          }

          // Show loading
          target.disabled = true;
          target.style.opacity = '0.5';

          // Clear from localStorage
          localStorage.removeItem('minimog-cart-discount-code');

          // Clear discount input field
          const discountInput = document.querySelector('input[name="discount"]');
          if (discountInput) {
            discountInput.value = '';
          }

          // Use Shopify's official Cart AJAX API to remove discount
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ discount: '' })
          })
            .then(response => response.json())
            .then(() => {
              // Wait a moment for Shopify to process
              return new Promise(resolve => setTimeout(resolve, 800));
            })
            .then(() => {
              // Refresh cart sections
              document.dispatchEvent(new CustomEvent('cart:refresh', {
                detail: { open: !document.location.pathname.includes('/cart') }
              }));

              // Re-enable button after refresh
              setTimeout(() => {
                target.disabled = false;
                target.style.opacity = '1';
              }, 800);
            })
            .catch((error) => {
              console.error('Error removing discount:', error);
              target.disabled = false;
              target.style.opacity = '1';
            });
        },
      });
    }

    updateCartNote() {
      const cartNoteValue = this.domNodes.cartNote.value;
      const body = JSON.stringify({ note: cartNoteValue });
      fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }
  }
  customElements.define("m-cart-addons", MCartAddons);
}